import i18next from "i18next";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { closeModal, openModal } from "../../REDUX/actions/confirmationModal";
import { bgImage } from "../../utils/utils";
import CustomButton from "../Common/CustomButton";
import "./ProductCard.css";
import defaultImage from "../../images/default-product.jpg";

const ProductCardFR = ({
  product,
  deleteProduct,
  duplicateProduct,
  showOrHideProductFR,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleDelete = () => {
    deleteProduct(product.id);
    if (product?.attributes?.localizations?.data[0]) {
      deleteProduct(product.attributes.localizations.data[0].id);
    }
    dispatch(closeModal());
  };

  const goToProduct = () =>
    navigate(`/products-fr/${product.id}`, {
      state: {
        id: product.id,
        idTrans: product.attributes.localizations?.data[0]?.id,
        enterWithLanguage: i18next.language,
      },
    });

  const showModal = () =>
    dispatch(
      openModal({
        type: "delete",
        confirmButtonText: "Supprimer",
        cancelButton: true,
        message: "Êtes-vous sûr(e) de vouloir supprimer le produit ?",
        callBack: handleDelete,
      })
    );

  const showDuplicateModal = () =>
    dispatch(
      openModal({
        type: "duplicate",
        confirmButtonText: "Dupliquer",
        cancelButton: true,
        message: "Voulez-vous dupliquer ce produit ?",
        callBack: () => {
          duplicateProduct(product.id);
          dispatch(closeModal());
        },
      })
    );

  const showModalPublish = (hide) => {
    dispatch(
      openModal({
        confirmButtonText: hide ? "Cacher" : "Afficher",
        cancelButton: true,
        message: hide
          ? "Êtes-vous sûr(e) de vouloir cacher le produit du site ?"
          : "Êtes-vous sûr(e) de vouloir afficher le produit sur le site ?",
        callBack: () => {
          showOrHideProductFR(
            [product.id, product.attributes.localizations?.data[0]?.id],
            hide
          );
        },
      })
    );
  };

  return (
    <div className={`border p-3 rounded `}>
      <div
        className="productCardImage position-relative"
        style={{
          backgroundImage: product?.attributes?.informations?.image?.data
            ? bgImage(product?.attributes?.informations?.image?.data)
            : `url(${defaultImage})`,
        }}
      >
        {" "}
        {product.attributes.hide && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <i
              className={`bi bi-eye-slash-fill text-red `}
              style={{ fontSize: "150px" }}
            ></i>
          </div>
        )}
      </div>

      <div className="text-start mt-4">
        {product.attributes?.informations?.name ?? "Produit français"}
        {product.attributes.hide ? " (caché)" : ""}
      </div>
      <div className="text-start f14 mt-2">
        {product.attributes?.informations?.capacity ?? 0} places
      </div>
      <div className="row mt-3">
        <div className="col-3">
          <CustomButton
            iconStart="trash-fill"
            type="red"
            callBack={showModal}
          />
        </div>
        <div className="col-3">
          <CustomButton
            iconStart="files"
            type="primary"
            callBack={showDuplicateModal}
          />
        </div>
        <div className="col-3">
          <CustomButton iconStart="pencil-fill" callBack={goToProduct} />
        </div>
        <div className="col-3" title="Cacher ou afficher le produit">
          <CustomButton
            type={product.attributes.hide ? "primary" : "red"}
            iconStart={product.attributes.hide ? "eye-fill" : "eye-slash-fill"}
            callBack={() =>
              showModalPublish(product.attributes.hide ? false : true)
            }
          />
        </div>
      </div>
    </div>
  );
};

export default ProductCardFR;
